export function getFormString(formData: FormData, key: string): string | null {
  const value = formData.get(key);
  return typeof value === 'string' ? value : null;
}

export function getRequiredFormString(formData: FormData, key: string): string {
  const value = getFormString(formData, key);
  if (value === null) {
    throw new Error(`Missing form field: ${key}`);
  }
  return value;
}
